import React from 'react';
import useAppVersion from '../../hooks/useAppVersion';

const AppUpdateBanner = () => {
  const { updateAvailable } = useAppVersion();

  if (!updateAvailable) return null;

  return (
    <div
      style={{ zIndex: 9999, transform: 'translateZ(0)', WebkitTransform: 'translateZ(0)' }}
      className="fixed bottom-0 left-0 right-0 bg-blue-600 text-white px-4 py-3 flex items-center justify-between shadow-lg sm:bottom-4 sm:left-4 sm:right-4 sm:rounded-xl"
    >
      <div className="flex items-center gap-3">
        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        <span className="text-sm font-medium">
          A new version is available. Refresh to get the latest updates.
        </span>
      </div>
      <button
        onClick={() => window.location.reload(true)}
        className="ml-4 flex-shrink-0 bg-white text-blue-600 text-sm font-semibold px-4 py-1.5 rounded-lg hover:bg-blue-50 transition"
      >
        Refresh
      </button>
    </div>
  );
};

export default AppUpdateBanner;
